export class Issue {
  issueTypeId = 0;
  name = '';
  description = '';

  constructor(obj) {
    obj && Object.assign(this, obj);
  }
}